import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Our_Mobile_App_Design_Process.svg")